import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuardAlumnoService as AuthGuardAlumno} from '../../services/auth-guard-alumno.service';
import {AlumnoComponent} from './alumno.component';
import {AdminComponent} from '../admin-alumno/admin.component';
import {AlumnoAsistenciasComponent} from '../asignaturas-alumno/componentes/alumno-asistencias.component';
import {AlumnoExamenComponent} from '../admin-alumno/componentes/alumno-examen.component';
import {AlumnoTaskComponent} from '../asignaturas-alumno/componentes/alumno-task.component';
import {UploadExamenComponent} from '../admin-alumno/componentes/upload-examen.component';
import {AlumnoAsignaturasComponent} from '../asignaturas-alumno/alumno-asignaturas.component';
import {AlumnoListadoComponent} from '../asignaturas-alumno/componentes/alumno-listado.component';
import {AlumnoNotasComponent} from '../asignaturas-alumno/componentes/alumno-notas.component';
import {AlumnoInboxComponent} from '../inbox/alumno-inbox.component';
import {ProfileContactoComponent} from '../../admin/admin-profile/componentes/profile-contacto.component';
import {ProfileEditComponent} from '../../admin/admin-profile/componentes/profile-edit.component';
import {ProfilePasswordComponent} from '../../admin/admin-profile/componentes/profile-password.component';
import {ProfileComponent} from '../../admin/admin-profile/profile.component';
import {AsistenciasComponent} from '../../componentes/asistencias/asistencias.component';
import {AgendaAlumnoComponent} from '../../componentes/agenda/agenda-alumno/agenda-alumno.component';
import {TablonUserComponent} from '../../componentes/tablon/tablon-user/tablon-user.component';


const routes: Routes = [
  {
    path: 'alumno',
    component: AlumnoComponent,
    canActivate: [AuthGuardAlumno],

    children: [
      {
        path: 'admin',
        component: AdminComponent,
        children: [
          {path: 'datos', component: AdminComponent},
          {path: 'task', component: AlumnoTaskComponent},
          {path: 'examenes', component: AlumnoExamenComponent},
          {path: 'asistencias', component: AsistenciasComponent},
          {path: 'examen', component: UploadExamenComponent},
          {path: '**', pathMatch: 'full', redirectTo: 'asistencias'}
        ]
      },
      {
        path: 'asignaturas',
        component: AlumnoAsignaturasComponent,
      },
      {
        path: 'estado/:asignatura',
        component: AlumnoListadoComponent,
        children: [
          {path: 'task', component: AlumnoTaskComponent},
          {path: 'notas', component: AlumnoNotasComponent},
          {path: 'asistencias', component: AlumnoAsistenciasComponent},
          {path: '**', pathMatch: 'full', redirectTo: 'task'}
        ]
      },
      {
        path: 'inbox',
        component: AlumnoInboxComponent
      },
      {
        path: 'tablonUser',
        component: TablonUserComponent,
      },
      {
        path: 'horario',
        component: AgendaAlumnoComponent
      },
      {
        path: 'profile',
        component: ProfileComponent,
        children: [
          {path: 'editar', component: ProfileEditComponent},
          {path: 'contacto', component: ProfileContactoComponent},
          {path: 'password', component: ProfilePasswordComponent},
          {path: '**', pathMatch: 'full', redirectTo: 'editar'}

        ]
      },
      {
        path: 'asistencias',
        component: AsistenciasComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class AlumnoRoutingModule {
}
